import { z } from "zod";
import { collectorRunKindSchema, collectorRunStatusSchema } from "./codes.js";
import { amountSchema, monthSchema, timestampSchema } from "./primitives.js";
export const collectorRunSchema = z.object({
    collectorRunId: z.uuid(),
    kind: collectorRunKindSchema,
    status: collectorRunStatusSchema,
    startedAt: timestampSchema,
    finishedAt: timestampSchema.nullable(),
    monthsFetched: z.array(monthSchema),
    resourceCount: z.number().int().nonnegative(),
    errorCode: z.string().nullable(),
});
export const inventoryStatusSchema = z.object({
    capturedAt: timestampSchema,
    uploadedAt: timestampSchema,
    clientId: z.string(),
    resourceCount: z.number().int().nonnegative(),
});
export const statusResponseSchema = z.object({
    periods: z.array(z.object({
        month: monthSchema,
        currency: z.string(),
        totalAmount: amountSchema,
        fetchedAt: timestampSchema,
        closed: z.boolean(),
    })),
    lastInventory: inventoryStatusSchema.nullable(),
    runs: z.array(collectorRunSchema),
});
//# sourceMappingURL=status.js.map